import React from 'react';

import { withStyles, Switch } from '@material-ui/core';

import styles from './index.styles';

const AntSwitch = withStyles(theme => styles(theme))(Switch);

export default AntSwitch;